import React from 'react'
import PropTypes from 'prop-types'

const Results = ({ results = null, onHide, collapseContent, onLocation }) => (
    <div className="search-results">
        {results === null && (
            <div className="spinner">
                <div className="bounce1" />
                <div className="bounce2" />
                <div className="bounce3" />
            </div>
        )}
        {results !== null && (
            <>
                {results.length < 1 && (
                    <div className="no-results">
                        <div>No results</div>
                    </div>
                )}
                {results.length > 0 && (
                    <table>
                        <thead>
                            <tr>
                                <th>Address</th>
                                <th>APN</th>
                            </tr>
                        </thead>
                        <tbody>
                            {results.map(parcel => (
                                <tr
                                    key={parcel.parcel_id}
                                    onClick={() => {
                                        onLocation(parcel.full_address)
                                        onHide()
                                        collapseContent()
                                        if (window.geocoder) {
                                            window.geocoder.query(parcel.full_address)
                                        }
                                    }}
                                >
                                    <td>{parcel.full_address}</td>
                                    <td>{parcel.parcel_apn}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </>
        )}
    </div>
)

Results.propTypes = {
    // parent
    collapseContent: PropTypes.func.isRequired,
    onLocation: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired,
    results: PropTypes.arrayOf(PropTypes.shape({})).isRequired
}

export default Results
